'use client';

import { CacheKey } from '@eliadmin/core/src/api/constants';
import { fetchSlugDetail } from '@eliadmin/core/src/api/slugs/slugs-api';
import { CourseDetailBought } from '@eliadmin/core/src/components/courses/course-detail-bought';
import { CourseDetailPublic } from '@eliadmin/core/src/components/courses/course-detail-public';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useSuspenseQuery } from '@tanstack/react-query';

type CourseRouterProps = {
  slug: string;
};

/** Kurzy, ktoré sú dostupné zdarma pre každého (aj bez aktívneho predplatného). */
const FREE_COURSE_IDS = [58];
export function CourseRouter(props: CourseRouterProps) {
  const locale = useLocaleStore(s => s.currentLocale);
  const me = useCustomerStore(s => s.me);

  const courseQuery = useSuspenseQuery({
    queryKey: [CacheKey.COURSE_DETAIL, props.slug, me?.authToken, locale],
    queryFn: () =>
      fetchSlugDetail({ locale, slug: props.slug, authToken: me?.authToken }).then(
        res => res['App\\Models\\Course\\Course'] ?? null,
      ),
  });

  const hasSubscription = (me?.customer?.active_subscriptions?.length ?? 0) > 0;

  if (!courseQuery.data) {
    return null;
  }

  const isFree = FREE_COURSE_IDS.includes(courseQuery.data.id);

  if (hasSubscription || isFree) {
    return <CourseDetailBought course={courseQuery.data} me={me?.customer} />;
  }

  return <CourseDetailPublic course={courseQuery.data} />;
}
